<template>
    <img class="max-w-100 img-center" alt="" v-if="url" :src="parseUrl(url)" />
</template>

<script>
import { defineComponent } from "vue";
import { parseUrl } from "../../../utils/util";

export default defineComponent({
    components: {},
    props: {
        url: {},
    },
    setup() {
        return { parseUrl };
    },
});
</script>
